import { useCallback, useEffect, useState } from "react";
import { metricsBus } from "@/common/buses";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";

export const useOrientation = () => {
  const [isPhone] = useState(useDeviceType() === deviceTypeEnum.PHONE);

  const changeHandler = useCallback((event: Event) => {
    const { type } = event.target as ScreenOrientation;

    if (isPhone) {
      metricsBus.emit("orientationChanged", { type });
    }
  }, [isPhone]);

  useEffect(() => {
    screen.orientation?.addEventListener("change", changeHandler);

    return () => {
      screen.orientation?.removeEventListener("change", changeHandler);
    };
  }, [changeHandler]);
};
